exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-controls[data-v-5b2e9c4d]{border-bottom:1px solid rgba(0,0,0,.1);padding:10px 20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff}.list-info[data-v-5b2e9c4d]{color:rgba(0,0,0,.4);text-transform:uppercase;font-weight:500;letter-spacing:1px;font-size:.72rem}.list-order[data-v-5b2e9c4d]{margin-left:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b2e9c4d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/orcamento/OrcamentoPage.vue
// module id = 555
// module chunks = 6